//import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Home } from "./pages/Home";
import { Reference } from "./pages/Reference";
import { CartBy } from './pages/CartBy';
import {PageIn} from './pages/PageIn';
import { UnderWest } from './pages/UnderWest';
import { Help } from './pages/Help'
import Nofoundpage from "./pages/Nofoundpage";
import { ForWeb } from "./pages/ForWeb";
import { Recent } from "./pages/MostRecent";
import { Read } from './pages/MostRead'
import { Deneder } from './pages/Politic'
import { DenederLegals } from './pages/Legals'
import { Game } from './pages/GoGame'

import "./style/App.css";


function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home/>} />
          <Route path="/recientes" element={<Recent/>}/>
          <Route path="/leidos" element={<Read/>}/>
          <Route path="/:ID" element={<Reference/>}/>
          <Route path="/Super" element={<CartBy/>}/>
          <Route path="/Super/:ID" element={<UnderWest/>}/>
          <Route path="/Help" element={<Help/>}/>
          <Route path="/aprende-programacion" element={<PageIn/>}/>
          <Route path="/Sobre-esta-web" element={<ForWeb/>}/>
          <Route path="/Politicas-de-privacidad" element={<Deneder/>}/>
          <Route path="/Avisos-legales" element={<DenederLegals/>}/>
          <Route path="/descargar-juegos-gratis" element={<Game/>}/>
          <Route path="*" element={<Nofoundpage/>}/>
        </Routes>
      </BrowserRouter>
    </>
  );
}
export default App;
